import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/api/auth.service';
import { Store } from '@ngrx/store';
import { UserActions } from '../states/auth/auth.actions';
import {
  ASSISTANT_AUTHORIZE_PATH,
  POST_LOGIN_RETURN_KEY,
} from '../helpers/global/assistant.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private _auth: AuthService,
    private _router: Router,
    private _store: Store
  ) {}
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._auth.isLoggedOut()) {
      this.rememberAuthorizeRequest(state.url);
      this._store.dispatch(UserActions.userLogout());
      this._router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }

  /**
   * The Claude connector opens `/assistant/authorize?request=…` in a fresh tab.
   * An operator without a session would land on the dashboard after logging
   * in and the pending authorization would be lost, so that one URL is kept
   * across the login. Deliberately scoped to the authorize path: every other
   * route keeps today's behaviour. sessionStorage (not a query param) so it
   * survives an intermediate 2FA step, and it never outlives the tab.
   */
  private rememberAuthorizeRequest(url: string): void {
    if (!url.startsWith(ASSISTANT_AUTHORIZE_PATH)) return;
    try {
      sessionStorage.setItem(POST_LOGIN_RETURN_KEY, url);
    } catch {
      // Storage unavailable (privacy mode): the operator re-opens the link.
    }
  }
}
